/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { TaskModifier } from '@kaiizen/kai-pro-api-react-state';
import { ScanLineItemOptimized } from '@kaiizen/kai-scan-template-system';
import CheckIcon from '@mui/icons-material/Check';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Menu, MenuItem } from '@mui/material';
import React, { useState } from 'react';

import { ScanDataMutators } from '../../State';
import { LAYOUT2 } from '../../Styles';

const MENU_BUTTON_STYLE = css`
  label: LINE_ITEM_MENU_BUTTON;
  cursor: pointer;
  width: 45px;
  height: 45px;
  padding: ${LAYOUT2.spacing1}px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text2);
  background: transparent;
  border: none;
  transition: color 0.2s;
  &:hover {
    color: var(--text);
  }
`;

const MENU_ITEM_STYLE = css`
  label: MENU_ITEM_STYLE;
  display: flex;
  align-items: center;
  gap: ${LAYOUT2.spacing1}px;
  padding: ${LAYOUT2.spacing1}px ${LAYOUT2.spacing2}px;
  min-width: 200px;
`;

const CHECK_ICON_CONTAINER_STYLE = css`
  label: CHECK_ICON_CONTAINER_STYLE;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LineItemStatusMenu = ({
  lineItem,
  groupId,
  taskId,
  optionId,
  scanDataMutators,
  enabledTaskModifiers,
  isEditable,
}: {
  lineItem: ScanLineItemOptimized;
  groupId: string;
  taskId: string;
  optionId: string;
  scanDataMutators: ScanDataMutators;
  enabledTaskModifiers: TaskModifier[];
  isEditable: boolean;
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event?: any) => {
    if (event) {
      event.stopPropagation();
    }
    setAnchorEl(null);
  };

  const handleToggleTag = (lineItemTag: TaskModifier['lineItemTag'], event: React.MouseEvent) => {
    event.stopPropagation();
    if (!isEditable) return;

    const newTags = { ...lineItem.tags };
    if (newTags[lineItemTag] === true) {
      const { [lineItemTag]: _removedTag, ...rest } = newTags;
      scanDataMutators.updateLineItem(groupId, taskId, optionId, lineItem.id, { tags: rest });
    } else {
      newTags[lineItemTag] = true;
      scanDataMutators.updateLineItem(groupId, taskId, optionId, lineItem.id, { tags: newTags });
    }
  };

  return (
    <div onClick={e => e.stopPropagation()}>
      <button css={MENU_BUTTON_STYLE} onClick={handleClick} disabled={!isEditable}>
        <MoreVertIcon fontSize='small' />
      </button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={e => e.stopPropagation()}
      >
        {enabledTaskModifiers.map(({ key, lineItemTag, displayName }) => (
          <MenuItem
            key={key}
            onClick={event => handleToggleTag(lineItemTag, event)}
            css={MENU_ITEM_STYLE}
          >
            <div css={CHECK_ICON_CONTAINER_STYLE}>
              {lineItem.tags?.[lineItemTag] === true && <CheckIcon fontSize='small' />}
            </div>
            {displayName}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};
